/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const ClinicApi = {
  public: {},
  private: {
    /**
     *  To upload csv patients to a clinic
     *  https://poscom-api.azurewebsites.net/api/ehr/import
     */
    importCSV: (payload, additionals) => ProtectedHttpClient.post(`/ehr/import`, payload, additionals),
    importDemoDataForPractice: ({ payload, additionals }) => ProtectedHttpClient.post(`/ehr/demo/patient/import`, payload, additionals),
    importDemoData: (payload, additionals) => ProtectedHttpClient.post(`/ehr/demo/practice/import`, payload, additionals),
    fetchActiveClinics: () => ProtectedHttpClient.get(`/bppractices`),
    /**
     * Fetch a specific clinic
     */
    fetchClinicData: ({ practiceId }) => ProtectedHttpClient.get(`/practicemetadata/${practiceId}`),
    // Update a specific clinic
    updateClinicData: ({ clinicData }) => ProtectedHttpClient.patch(`/practice/update`, clinicData),
    // Fetch a clinic's facility
    fetchClinicFacility: ({ facilityId, medicalGroupId }) => ProtectedHttpClient.get(`/facility/${facilityId}/${medicalGroupId}`)
  },
};
export default ClinicApi;
